"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Backdrop = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _hooks = require("../../hooks");

var _backdrop = require("./backdrop.style");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node
} : {};
const defaultProps = {
  children: null
};

const Backdrop = ({
  children
}) => {
  const {
    isMobile
  } = (0, _hooks.useDeviceDetect)();

  const renderBackdrop = () => (0, _core.jsx)(_backdrop.Container, {
    "data-testid": "modal-backdrop"
  }, (0, _core.jsx)(_backdrop.Container.Overlay, null, children));

  return isMobile ? renderBackdrop() : (0, _core.jsx)(_backdrop.Animation, {
    key: "backdrop",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  }, renderBackdrop());
};

exports.Backdrop = Backdrop;
process.env.NODE_ENV !== "production" ? Backdrop.propTypes = propTypes : void 0;
Backdrop.defaultProps = defaultProps;
Backdrop.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Backdrop",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};